import { JobType } from '../../api/jobs.dao';
import { ContextExecutionParams, LongRunningJob } from './index';

export abstract class ExecutionRuntime<ExecutionContext, T> {
    abstract getExecutionContext(): ExecutionContext;
    abstract getParams(): ContextExecutionParams<T>;
    abstract isReady(): boolean;
    abstract getJobByType(type: JobType): LongRunningJob;
    abstract onComplete(type: JobType, handler: (() => void)): void;
}
